import React from "react";
import { Topbar } from "@/components/layout/Topbar";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Inbox, RefreshCcw } from "lucide-react";

export default function ReviewPage() {
    return (
        <>
            <Topbar title="Cola de revisión" subtitle="Extracciones LLM con baja confianza (shell)" />
            <div className="p-3 md:p-4 flex-1 overflow-auto">
                <Card data-testid="review-queue-panel">
                    <CardContent className="py-16 flex flex-col items-center justify-center text-center gap-3">
                        <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center">
                            <Inbox className="h-6 w-6 text-muted-foreground" />
                        </div>
                        <div className="space-y-1">
                            <div className="text-sm font-medium">Cola vacía</div>
                            <p className="text-xs text-muted-foreground max-w-md">
                                El extractor automático de mensajes (módulo posterior) no está activo todavía.
                                Cuando lo esté, las extracciones con confianza &lt; 0.85 aparecerán aquí para revisión humana.
                            </p>
                        </div>
                        <Button variant="outline" size="sm" data-testid="review-refresh-button" onClick={() => window.location.reload()}>
                            <RefreshCcw className="h-3.5 w-3.5 mr-2" />
                            Refrescar
                        </Button>
                    </CardContent>
                </Card>
            </div>
        </>
    );
}
